import { GalleryUI } from "./GalleryUI";
import { useVariant } from "@/hooks/useVariant/useVariant";
import { useSocialProofMessages } from "@/components/Galleries/hooks/useSocialProofMessages";
import {
  standardComponent,
  useStandardProps,
} from "@/context/StandardPropsContext/StandardPropsContext";

export const Gallery = standardComponent("Gallery", () => {
  const { product, sizes } = useStandardProps();
  const { variant } = useVariant(product);
  const media = "media" in product ? product.media : null;
  const videos = media?.videos || [];
  const { socialProofMessagesProperties } = useSocialProofMessages();

  if (!variant) return null;

  return (
    <GalleryUI
      title={variant.title}
      images={variant.images}
      videos={videos}
      sizes={sizes}
      hasSocialProofMessagesExperience={true}
      socialProofMessagesProperties={socialProofMessagesProperties}
    />
  );
});
